import {Databases, Query} from "appwrite";
import {client, database_id} from "../lib/appwrite";
import {v4 as uuidv4} from "uuid";
import {ScheduleItem} from "../types/schedule";

const SCHEDULE_COLLECTION = "6794c60700198a215142"

const databases = new Databases(client);

export const scheduleService = {

  async list(queries: string[] = [], limit: number = 100): Promise<ScheduleItem[]> {
    try {
      const response = await databases.listDocuments(
        database_id,
        SCHEDULE_COLLECTION,
        [
          Query.limit(limit),
          ...queries
        ]
      );
      const list = response.documents.map(doc => doc as unknown as ScheduleItem);
      return list;
    } catch (error) {
      throw error;
    }
  },

  async create(data: ScheduleItem): Promise<ScheduleItem> {
    try {
      const createdItem = await databases.createDocument(
        database_id,
        SCHEDULE_COLLECTION,
        uuidv4(),
        data
      ) as unknown as ScheduleItem;

      return createdItem;
    } catch (error) {
      throw error;
    }
  },

  async update(data: ScheduleItem): Promise<ScheduleItem> {
    try {
      const id = data.$id as string
      const {$id, ...correctData} = data
      const updatedItem = await databases.updateDocument(
        database_id,
        SCHEDULE_COLLECTION,
        id,
        correctData
      ) as unknown as ScheduleItem;

      return updatedItem;
    } catch (error) {
      throw error;
    }
  },

  async delete(id: string): Promise<void> {
    try {
      await databases.deleteDocument(
        database_id,
        SCHEDULE_COLLECTION,
        id
      );
    } catch (error) {
      throw error;
    }
  },
}